module.exports = __webpack_public_path__ + "static/media/FusionGinssen-01.9f4f979a.jpg";